import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type X7Machine } from "@packsize/schemas/machines";

import { getX7Machines } from "@/api/machines/x7-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { X7_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getX7MachinesQuery = <TData = X7Machine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: X7_MACHINES_QUERY_KEY,
	queryFn: getX7Machines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useX7Machines = (
	options?: UseMachinesQueryOptions<X7Machine[], Error>,
): UseQueryResult<X7Machine[], Error> => {
	return useQuery<X7Machine[], Error>(getX7MachinesQuery(options));
};
